export const handleNaN = (value) => {
  return isNaN(value) ? 0 : value;
};
